<template>
  <footer class="app-footer">
    <div class="footer-content container">
      <div class="footer-section brand">
        <img src="@/assets/logo-white.png" alt="Fixtronic" class="footer-logo" />
        <p>Digitale Gerätewartung und Defektmeldung für Fitnessstudios. Einfach, effizient und aus Heilbronn.</p>
      </div>
      <div class="footer-section">
        <h4>Links</h4>
        <ul>
          <li><a href="https://link.facetronic.de/fixtronic" target="_blank">Live-Demo</a></li>
          <li><a href="https://fixtronic.io/" target="_blank" rel="noopener noreferrer">Login</a></li>
        </ul>
      </div>
      <div class="footer-section">
        <h4>Rechtliches</h4>
        <ul>
          <li><router-link to="/impressum">Impressum</router-link></li>
          <li><router-link to="/datenschutz">Datenschutz</router-link></li>
          <li><a href="#" @click.prevent="openCookieSettings">Cookie-Einstellungen</a></li>
        </ul>
      </div>
      <div class="footer-section">
        <h4>Kontakt</h4>
        <ul>
          <li><a href="https://facetronic.de/kontakt" target="_blank" rel="noopener noreferrer">Kontaktformular</a></li>
          <li><a href="mailto:info@facetronic.de">info@facetronic.de</a></li>
          <li><a href="tel:+4971313859900">+49 7131 3859900</a></li>
        </ul>
      </div>
    </div>
    <div class="footer-bottom container">
      <p>&copy; {{ new Date().getFullYear() }} Facetronic UG (haftungsbeschränkt)</p>
      <div class="footer-legal">
        <span>Facetronic UG (haftungsbeschränkt) · Im Zukunftspark 4, 74076 Heilbronn</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  inject: ['openCookieSettings'],
}
</script>

<style scoped>
.app-footer {
  background-color: #1a1a2e;
  color: #d1d5db;
  padding: 64px 0 0;
  font-size: 0.95em;
}

.footer-content {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr;
  gap: 40px;
  padding-bottom: 48px;
}

.footer-logo {
  height: 36px;
  width: auto;
  margin-bottom: 16px;
}

.brand p {
  color: #9ca3af;
  line-height: 1.7;
  max-width: 280px;
}

.footer-section h4 {
  color: white;
  font-size: 1em;
  font-weight: 600;
  margin-bottom: 16px;
}

.footer-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-section ul li {
  margin-bottom: 10px;
}

.footer-section a,
.footer-section span {
  color: #9ca3af;
  text-decoration: none;
  transition: color 0.2s ease;
  line-height: 1.5;
}

.footer-section a:hover {
  color: white;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 24px;
  padding-bottom: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-bottom p {
  color: #6b7280;
  margin: 0;
  font-size: 0.9em;
}

.footer-legal {
  display: flex;
  gap: 24px;
}

.footer-legal a {
  color: #6b7280;
  text-decoration: none;
  font-size: 0.9em;
  transition: color 0.2s ease;
}

.footer-legal a:hover {
  color: white;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }
  .brand {
    grid-column: 1 / -1;
  }
  .footer-bottom {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .footer-content {
    grid-template-columns: 1fr;
  }
}
</style>
